"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var icon_1 = require("../icon");
var marquee_1 = require("../marquee");
exports.default = (function (_a) {
    var theme = _a.theme, className = _a.className, label = _a.label, iconName = _a.iconName, _b = _a.iconSize, iconSize = _b === void 0 ? 3 : _b, _c = _a.activeMarquee, activeMarquee = _c === void 0 ? true : _c;
    return (React.createElement("div", { className: classnames_1.default(theme["page-title"], className) },
        iconName ? React.createElement("div", { className: theme.icon },
            React.createElement(icon_1.Icon, { iconName: iconName, size: iconSize })) : null,
        React.createElement("div", { className: theme.label },
            React.createElement(marquee_1.Marquee, { active: activeMarquee }, label))));
});
